import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { rootReducer } from './reducers';
import rootSagas from './sagas';
import { pageVisibilityMiddleware } from './middleware/pageVisibilityMiddleware';
import sgmReportMiddleware from './middleware/sgmReportMiddleware';
export const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware, pageVisibilityMiddleware, sgmReportMiddleware];
export const store = configureStore({
  reducer: rootReducer,
  middleware: middleware,
});

sagaMiddleware.run(rootSagas);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
(window as any).store = store;
